import { library } from '@fortawesome/fontawesome-svg-core';
import { fontAwesomeSolidIcons } from './icons.font-awesome-solid';
import { fontAwesomeRegularIcons } from './icons.font-awesome-regular';
import { fontAwesomeBrandsIcons } from './icons.font-awesome-brands';
import { initFeather } from './icons.feather';
export function addIcons() {
    initFeather();
    library.add(fontAwesomeSolidIcons, fontAwesomeRegularIcons, fontAwesomeBrandsIcons);
}
